// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2KM8l","colMin":"styles_colMin__1Q9Fh","colCheckbox":"styles_colCheckbox__3hPkR"};